import { shortDate, weekdayName } from '../daily-sales-format';

export interface DailySalesChartTooltipProps {
  active?: boolean;
  label?: string;
  rows?: ReadonlyArray<{ name?: unknown; value?: unknown; color?: string }>;
  format: (value: number) => string;
  today: string;
}

export function DailySalesChartTooltip({
  active,
  label,
  rows,
  format,
  today,
}: DailySalesChartTooltipProps) {
  if (!active || !label || !rows?.length) return null;
  const items = rows.map((r) => ({
    name: String(r.name),
    value: Number(r.value),
    color: r.color ?? 'currentColor',
  }));
  const total = items.reduce((sum, r) => sum + r.value, 0);

  return (
    <div className="nb-card" style={{ padding: '8px 10px', fontSize: 12, minWidth: 180 }}>
      <div style={{ fontWeight: 600, marginBottom: 4 }}>
        {weekdayName(label)} {shortDate(label)}
        {label === today ? ' (so far)' : ''}
      </div>
      {items.map((r) => (
        <div key={r.name} style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
          <span>
            <i className="nb-ds-swatch" style={{ background: r.color }} />
            {r.name}
          </span>
          <span className="nb-tabular">{format(r.value)}</span>
        </div>
      ))}
      {items.length > 1 && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 4,
            fontWeight: 600,
          }}
        >
          <span>Total</span>
          <span className="nb-tabular">{format(total)}</span>
        </div>
      )}
    </div>
  );
}
